module.exports = __webpack_public_path__ + "img/filesHare (2).6ceb89bb.png";